export default {
    name: "MultiSelectCheckboxHandling",

    data () {
        return {
            // The list that will hold all the selected rows
            selectedRows: [],
            // The name of the property that holds the data from which the user will be selecting
            // for example when this mixin is used on the AssetList this property will be "mutableAssetsList"
            dataListPropertyName: "",
            // The Uri that will be used to get all the selected row ids when the user clicks the select all button
            selectAllUri: "",
        };
    },

    methods: {
        handlePageSelection (command) {
            switch (command) {
                case "select-page":
                    this.toggleSelectedOnVisibleRows(true);
                    break;
                case "select-all":
                    this.selectAll();
                    break;
                case "un-select-all":
                    this.clearSelection();
                    break;
            }
        },

        toggleRowSelection (recordId) {
            if (this.isChecked(recordId)) {
                this.selectedRows.splice(this.selectedRows.indexOf(recordId), 1);
            } else {
                this.selectedRows.push(recordId);
            }
        },

        toggleSelectedOnVisibleRows (bool) {
            const dataList = this[this.dataListPropertyName];
            if (!Array.isArray(dataList)) {
                console.error(`The property '${this.dataListPropertyName}' does not refer to an array.`);
                return;
            }

            if (bool) {
                dataList.forEach(record => {
                    let id = record.id;
                    if (!this.isChecked(id)) {
                        this.selectedRows.push(id);
                    }
                });
            } else {
                dataList.forEach(record => {
                    let id = record.id;
                    if (this.isChecked(id)) {
                        this.selectedRows.splice(this.selectedRows.indexOf(id), 1);
                    }
                });
            }
        },

        clearSelection () {
            this.selectedRows.splice(0);
        },

        isChecked (recordId) {
            return this.selectedRows.includes(recordId);
        },

        selectAll () {
            axios.get(this.selectAllUri, {
                params: this.searchParams
            }).then((response) => {
                this.selectedRows = response.data;
            }).catch((errors) => {
                toastr.error(errors);
            });

        },
    }
};
